import { Module } from 'vuex';

import { Subscription } from 'frontend/types/premium/index';
import { RootState, User, WadtudrActions } from 'frontend/types';

const wadtudrActions: Module<WadtudrActions, RootState> = {
  namespaced: true,
  state: () => ({
    subscriptions: [] as Subscription[],
    user: undefined,
  }),
  mutations: {
    setValue(state: WadtudrActions, value: WadtudrActions) {
      Object.assign(state, value);
    },
  },
};

export default wadtudrActions;
